const listaDeConclusoes = (state) => {
    return state.items;
}

const loadingConclusoes = (state) => {
    return state.loading
}

export {
    listaDeConclusoes,
    loadingConclusoes
}